import { Form, Input, message } from 'antd';
import React, { useState } from 'react';
import colors from '../../../../share/constants/constants';
import Button from '../../../../components/common/button';
import { createEmoji } from '../../../../api/user';

const EmojiForm = ({ setShowForm }) => {
  const [loader, setLoader] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoader(true);
      const res = await createEmoji(values);
      if (res) {
        setShowForm(false);
        message.success(`Emoji Created Successfully ${res?.emoji}`);
      }
    } catch (error) {
      message.error(error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  return (
    <div>
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          name="emoji"
          label="Enter your emoji here"
          rules={[
            {
              required: true,
              message: 'This field is required',
            },
          ]}
        >
          <Input
            placeholder="Emoji"
            className="h-[54px] focus:bg-white focus:border-primaryBlue hover:border-primaryBlue"
          />
        </Form.Item>
        <div className=''>
          <Form.Item>
            <Button
              color={colors.primaryBlue}
              title="Save"
              htmlType="submit"
              loading={loader}
              className='w-[250px]'
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default EmojiForm;
